import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { BindSPANavigationForCTADirectiveModule } from "@hermes/fragments/bind-spa-navigation-for-cta";
import { MediaCtaModule } from "@hermes/media-cta";
import { TrustHtmlPipeModule } from "@hermes/utils-generic/pipes/trust-html";

import { CHAPTERS_COMPONENT } from "../../core";
import { AnimateOnScrollDirectiveModule } from "../../directives/animate-on-scroll/animate-on-scroll.module";
import { ResolveTokensPipeModule } from "../../pipes/resolve-tokens-pipe.module";

import { BlockMediaTextComponent } from "./block-media-text.component";

@NgModule({
    imports: [
        CommonModule,
        AnimateOnScrollDirectiveModule,
        BindSPANavigationForCTADirectiveModule,
        ResolveTokensPipeModule,
        TrustHtmlPipeModule,
        MediaCtaModule,
    ],
    declarations: [BlockMediaTextComponent],
    providers: [
        { provide: CHAPTERS_COMPONENT, useValue: BlockMediaTextComponent },
    ],
})
export class BlockMediaTextModule {}
